import React, { useEffect, useState } from 'react';
import { CalendlyEventListener as CalendlyEventListenerBase, EventScheduledEvent, InlineWidget } from 'react-calendly';

interface CalendlyEventListenerProps {
  onEventScheduled?: (e: EventScheduledEvent) => void;
}
const CalendlyEventListener = CalendlyEventListenerBase as unknown as React.FC<CalendlyEventListenerProps>;

export interface CalendlyInlineWidgetProps {
  url: string;
  utmContent: string;
  prefill?: {
    name?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
  };
  onEventScheduled?: (e: EventScheduledEvent) => void;
}

export const CalendlyInlineWidget: React.FC<CalendlyInlineWidgetProps> = ({
  url,
  utmContent,
  prefill,
  onEventScheduled,
}) => {
  const [iframeHeight, setIframeHeight] = useState<string | null>(null);

  useEffect(() => {
    function handleMessage(e: MessageEvent): void {
      try {
        const data =
          typeof e.data === 'string'
            ? (JSON.parse(e.data) as { event?: string; payload?: { height?: string } })
            : e.data;
        if (data?.event === 'calendly.page_height' && data.payload?.height) {
          setIframeHeight(data.payload.height);
        }
      } catch {
        // ignore non-JSON messages from other sources
      }
    }
    window.addEventListener('message', handleMessage);
    return (): void => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <>
      <CalendlyEventListener onEventScheduled={onEventScheduled} />
      <InlineWidget
        url={url}
        prefill={prefill}
        utm={{ utmContent }}
        styles={{ height: iframeHeight ?? '100px', minWidth: '320px' }}
      />
    </>
  );
};
